import { Typography } from '@mui/material'
import moment from 'moment'
import 'moment-timezone'

import { useStyles } from './styles'
import { useMe } from 'src/hooks'
import { HelperWrapper } from '../helper-wrapper'

interface IFormTimestampProps {
  created_at?: Date
  created_by?: string
  updated_at?: Date
  updated_by?: string
}

const FormTimestamp = ({ created_at, created_by, updated_at, updated_by }: IFormTimestampProps) => {
  const classes = useStyles()
  const { data: user } = useMe()

  return (
    <div className={classes.wrapper}>
      <div>
        <Typography className={classes.dateText}>
          <HelperWrapper
            t="table-created-column"
            isColorInherited
            size={12}
            verticalPosition={15}
          />
        </Typography>
        <Typography className={classes.timeText}>
          {moment(created_at)
            .tz(user?.timezone ?? 'UTC')
            .format('LLL')}{' '}
          <HelperWrapper t="changed-by-label" isColorInherited size={11} />
          &nbsp;{created_by || '-'}
        </Typography>
      </div>
      <div>
        <Typography className={classes.dateText}>
          <HelperWrapper t="last-modified-label" isColorInherited size={12} verticalPosition={15} />
        </Typography>
        <Typography className={classes.timeText}>
          {moment(updated_at)
            .tz(user?.timezone ?? 'UTC')
            .format('LLL')}{' '}
          <HelperWrapper t="changed-by-label" isColorInherited size={11} />
          &nbsp;{updated_by || '-'}
        </Typography>
      </div>
    </div>
  )
}

export { FormTimestamp }
